export default "<img [src]=\"picture\" class=\"case-avatar rounded-circle {{class}}\">\n";